import React, { useEffect, useState } from 'react';

import { Tabs } from '@mantine/core';
import { IconUserCircle, IconUsersGroup } from '@tabler/icons-react';
import { DashboardPageWrapper } from 'components/DashboardPageWrapper';
import { TabPanelWrapper } from 'components/TabPanelWrapper';
import { OrganisationTeamsTab } from 'pages/Organisation/OrganisationTeamsTab';
import { OrganisationUsersTab } from 'pages/Organisation/OrganisationUsersTab';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { ROUTE_LINKS } from 'shared/constants/route-links';

const TAB_PATHS = {
  USERS: 'users',
  TEAMS: 'teams'
};

export function OrganisationPage() {
  const { t } = useTranslation();
  const { tabName } = useParams();
  const navigate = useNavigate();

  const getActiveTabFromPath = () => {
    if (!tabName) return TAB_PATHS.USERS;
    if (!Object.values(TAB_PATHS).includes(tabName)) return TAB_PATHS.USERS;
    if (tabName === TAB_PATHS.TEAMS) {
      return TAB_PATHS.TEAMS;
    }
    return tabName;
  };

  const [activeTab, setActiveTab] = useState<string>(getActiveTabFromPath());

  const TABS = [
    {
      value: TAB_PATHS.USERS,
      component: <OrganisationUsersTab />,
      icon: <IconUserCircle />,
      label: t('ORGANISATION.USERS.TITLE')
    },
    {
      value: TAB_PATHS.TEAMS,
      component: <OrganisationTeamsTab />,
      icon: <IconUsersGroup />,
      label: t('ORGANISATION.TEAMS.TITLE')
    }
  ];

  useEffect(() => {
    navigate(`${ROUTE_LINKS.organisation}/${activeTab}`);
  }, [activeTab]);

  return (
    <DashboardPageWrapper title={t('APP.DASHBOARD_SECTIONS.ORGANISATION')}>
      <Tabs value={activeTab} inverted onTabChange={(tabPath) => setActiveTab(tabPath?.toString() ?? TAB_PATHS.USERS)}>
        <Tabs.List>
          {TABS.map((tab, key) => {
            return (
              <Tabs.Tab key={key} value={tab.value} icon={tab.icon}>
                {tab.label}
              </Tabs.Tab>
            );
          })}
        </Tabs.List>
        {TABS.map((tab, key: number) => {
          return (
            <Tabs.Panel key={key} value={tab.value}>
              <TabPanelWrapper>{tab.component}</TabPanelWrapper>
            </Tabs.Panel>
          );
        })}
      </Tabs>
    </DashboardPageWrapper>
  );
}
